<script lang="ts" setup>
import ImMsgDate from './ImMsgDate.vue';

interface Props {
  recall?: number;
  avatar?: string;
  placement?: string;
  loading?: boolean;
  error?: boolean;
  sensitive?: boolean;
  unread?: boolean;
  showDatetime?: boolean;
  time: number;
}

const {
  recall = 0,
  placement = 'start',
  avatar = '',
  loading = false,
  error = false,
  sensitive = false,
  showDatetime = true,
  time,
} = defineProps<Props>();

const emit = defineEmits(['retry']);

function handleRetry() {
  emit('retry');
}
</script>

<template>
  <div class="im-msg-box">
    <div
      v-if="recall === 1"
      class="text-colorTextTertiary mb-2 text-center text-sm leading-[22px]"
    >
      老师已撤回一条消息
    </div>
    <div v-else>
      <ImMsgDate v-if="showDatetime" :time="time" />
      <div class="im-msg-content-wrapper" :class="placement">
        <a-avatar
          :size="42"
          :draggable="false"
          :src="avatar"
          class="im-msg-avatar !border-none"
        />
        <div class="im-msg-content">
          <slot />
          <a-badge v-if="unread" dot class="im-msg-status-badge" />
        </div>
        <div class="im-msg-status self-center">
          <div>
            <img
              v-if="loading"
              class="spin-loading h-4 w-4"
              src="@core/assets/image/im/icon-loading.svg"
              alt="loading"
            />
            <img
              v-else-if="error"
              class="h-4 w-4 cursor-pointer"
              src="@core/assets/image/im/icon-error.svg"
              alt="error"
              @click="handleRetry"
            />
            <img
              v-else-if="sensitive"
              class="h-4 w-4"
              src="@core/assets/image/im/icon-sensitive.svg"
              alt="sensitive"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.im-msg-content-wrapper {
  @apply flex items-start justify-start gap-3;
}

.im-msg-content-wrapper .im-msg-avatar {
  @apply order-1;
}
.im-msg-content-wrapper .im-msg-content {
  max-width: 368px;
  @apply bg-colorFillSecondary text-colorText relative order-2 rounded-lg rounded-tl-sm px-4 py-3 text-sm leading-[22px];
}
.im-msg-content-wrapper .im-msg-status {
  @apply order-3;
}

.im-msg-content-wrapper.end {
  @apply flex items-start justify-end;
}
.im-msg-content-wrapper.end .im-msg-avatar {
  @apply order-3;
}
.im-msg-content-wrapper.end .im-msg-content {
  @apply bg-info/10 order-2 rounded-lg rounded-tl-lg rounded-tr-sm;
}
.im-msg-content-wrapper.end .im-msg-status {
  @apply order-1;
}

.im-msg-status-badge {
  @apply !absolute right-0  top-0;
}

.im-msg-status-badge :deep(.ant-badge-dot) {
  width: 9px;
  height: 9px;
  box-shadow: 0 0 0 1.5px #fff;
}
</style>
